import flagsmith from 'flagsmith';

import { Flags } from './flags';

export function isSignupDisabled(): boolean {
  if (flagsmith.hasFeature(Flags.SELLER_CORE_SIGNUP_DISABLED)) {
    return true;
  }

  const closeAt = flagsmith.getValue(Flags.SELLER_CORE_SIGNUP_DISABLED);

  if (typeof closeAt !== 'string' || !closeAt) {
    return false;
  }

  const closeDate = new Date(closeAt);

  return !Number.isNaN(closeDate.getTime()) && Date.now() >= closeDate.getTime();
}
